<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="tvandroid"
            class="px-8"
            gradient="to top right, rgba(246, 225, 3, 0.47), rgba(246, 225, 3, 0.47)"
            :src="app.bg[index_bg]">
            <v-row 
              align="center" 
              justify="center"
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="3">
                <v-card
                  flat
                  color="transparent">
                  <div>
                    <div
                      class="mb-16">
                      <v-img 
                        contain
                        width="150"
                        height="150"
                        alt="tvandroid"  
                        :src="app.logo"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-card
                      flat
                      color="#FFFFFFB2"
                      class="border-radius">
                      <v-card-text
                        class="pa-8">
                        <div
                          class="text-center mb-6">
                          <div
                            class="title font-weight-bold black--text mb-2">
                            Base Url
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left">
                            <ValidationProvider 
                              name="url" 
                              rules="required" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="https://venus.smartiv.id"
                                prepend-inner-icon="mdi-code-json"

                                vv-uppercase

                                v-model="form.url"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver>

                        <div 
                          class="text-center mb-4">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="save"
                            block
                            x-large
                            width="170"
                            elevation="0"
                            class="title font-weight-bold white--text text-capitalize"
                            style="border-radius: 8px; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                            Save
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,

        app: {
          logo: require('@/assets/logo/favicon.png'),
          logo: require('@/assets/logo/favicon.png'),
          bg: [require('@/assets/background/bg_visuality.jpg')]
        },

        index_bg: 0,

        form: {
          url: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      },
      baseurllocal () {
        return this.$store.state.baseurllocal
      }
    },
    mounted () {
      let company = {
        company_name: 'SMARTIV',
        logo: require('@/assets/logo/logo_color.png')
      }

      TokenService.saveCompany(JSON.stringify(company))
      this.$store.commit("setCompany", company)

      TokenService.saveColor('#0786BE')
      this.$store.commit("setColor", '#0786BE')

      this.form.url = this.baseurllocal

      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchLogo()
        this.fetchBg()
      },

      async fetchLogo () {
        let params = {
          key: 'APP_LOGO'
        }

        await get(`public/config/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.app.logo = res.result.data[0].value
          }
        })
      },

      async fetchBg () {
        let params = {
          key: 'APP_BACKGROUND_SLIDER_JSON'
        }

        await get(`public/config/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.app.bg = res.result.data[0].value_object.wallpaper

            setInterval(this.bg_time, 10000)
          }
        })
      },

      bg_time () {
        if (++this.index_bg >= this.app.bg.length)
        this.index_bg = 0
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          
          TokenService.saveBaseurllocal(this.form.url)
          this.$store.commit("setBaseurllocal", this.form.url)

          window.location = `/login`
        }
      }
    }
  }
</script>